import { render, staticRenderFns } from "./vditor.vue?vue&type=template&id=2f82f481"
import script from "./vditor.vue?vue&type=script&lang=ts"
export * from "./vditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports